import { observable, action, toJS, computed } from 'mobx'

class SearchStore {
    @observable public searchType: number | undefined = 1
    @observable public searchText: string = ''
    @observable public governingLaw: string = ''
    @observable public counterparty: string = ''
    @observable public language: string = ''
    @observable public disputeResolution: string = ''
    @observable public contractType: number = 0
    @observable public isConfidentiality: boolean = false
    @observable public noConfidentiality: boolean = false
    @observable public isChangeOfControl: boolean = false
    @observable public noChangeOfControl: boolean = false
    @observable public isIndemnity: boolean = false
    @observable public noIndemnity: boolean = false
    @observable public sensitivity: string = ''
    @observable public current: boolean = true
    @observable public historical: boolean = false
    @observable public date_sign_start: string = ''
    @observable public date_sign_end: string = ''
    @observable public termination_start: string = ''
    @observable public termination_end: string = ''
    @observable public contract_sum_start: string = ''
    @observable public contract_sum_end: string = ''
    @observable public isOpenEnded: boolean = false
    @observable public noOpenEnded: boolean = false
    @observable public ids: number[] = []
    @observable public focus: string[] = []

    @computed
    public get confidentiality() {
        if ((this.isConfidentiality && this.noConfidentiality)
            || (!this.isConfidentiality && !this.noConfidentiality)) {
            return ''
        } else {
            return this.isConfidentiality ? 'yes' : 'no'
        }
    }

    @computed
    public get changeOfControl() {
        if ((this.isChangeOfControl && this.noChangeOfControl)
            || (!this.isChangeOfControl && !this.noChangeOfControl)) {
            return ''
        } else {
            return this.isChangeOfControl ? 'yes' : 'no'
        }
    }

    @computed
    public get indemnity() {
        if ((this.isIndemnity && this.noIndemnity)
            || (!this.isIndemnity && !this.noIndemnity)) {
            return ''
        } else {
            return this.isIndemnity ? 'yes' : 'no'
        }
    }

    @computed
    public get open_ended() {
        if ((this.isOpenEnded && this.noOpenEnded)
            || (!this.isOpenEnded && !this.noOpenEnded)) {
            return ''
        } else {
            return this.isOpenEnded ? 'yes' : 'no'
        }
    }

    @action
    public clear() {
        this.searchType = 1
        this.searchText = ''
        this.governingLaw = ''
        this.counterparty = ''
        this.language = ''
        this.disputeResolution = ''
        this.contractType = 0
        this.isConfidentiality = false
        this.noConfidentiality = false
        this.isChangeOfControl = false
        this.noChangeOfControl = false
        this.isIndemnity = false
        this.noIndemnity = false
        this.sensitivity = ''
        this.current = true
        this.historical = false
        this.date_sign_start = ''
        this.date_sign_end = ''
        this.termination_start = ''
        this.termination_end = ''
        this.contract_sum_start = ''
        this.contract_sum_end = ''
        this.isOpenEnded = false
        this.noOpenEnded = false
        this.ids = []
        this.focus = []
    }

    @action
    public setIds(ids: number[]) {
        this.ids = ids
    }

    @action
    public setFocus(focus: string[]) {
        this.focus = focus
    }

    @action
    public setSearchType(searchType: number | undefined) {
        this.searchType = searchType
    }

    @action
    public setSearchText(searchText: string) {
        this.searchText = searchText
    }

    @action
    public setGoverningLaw(governingLaw: string) {
        this.governingLaw = governingLaw
    }

    @action
    public setCounterparty(counterparty: string) {
        this.counterparty = counterparty
    }

    @action
    public setLanguage(language: string) {
        this.language = language
    }

    @action
    public setContractType(contractType: number) {
        this.contractType = contractType
    }

    @action
    public modifyIsIndemnity(isIndemnity: boolean) {
        this.isIndemnity = isIndemnity
    }

    @action
    public modifyNoIndemnity(noIndemnity: boolean) {
        this.noIndemnity = noIndemnity
    }

    @action
    public modifyIsChangeOfControl(isChangeOfControl: boolean) {
        this.isChangeOfControl = isChangeOfControl
    }

    @action
    public modifyNoChangeOfControl(noChangeOfControl: boolean) {
        this.noChangeOfControl = noChangeOfControl
    }

    @action
    public modifyIsConfidentiality(isConfidentiality: boolean) {
        this.isConfidentiality = isConfidentiality
    }

    @action
    public modifyNoConfidentiality(noConfidentiality: boolean) {
        this.noConfidentiality = noConfidentiality
    }

    @action
    public modifyIsOpenEnded(isOpenEnded: boolean) {
        this.isOpenEnded = isOpenEnded
    }

    @action
    public modifyNoOpenEnded(noOpenEnded: boolean) {
        this.noOpenEnded = noOpenEnded
    }

    @action
    public setSensitivity(sensitivity: string) {
        this.sensitivity = sensitivity
    }

    @action
    public setCurrent(current: boolean) {
        this.current = current
    }

    @action
    public setHistorical(historical: boolean) {
        this.historical = historical
    }

    // @action
    // public setSignDateRange(dateStrings: [string, string]) {
    //     this.date_sign_start = dateStrings[0]
    //     this.date_sign_end = dateStrings[1]
    // }

    @action
    public setSignDateStart(value: string) {
        this.date_sign_start = value
    }

    @action
    public setSignDateEnd(value: string) {
        this.date_sign_end = value
    }

    @action
    public setTermStartDate(value: string) {
        this.termination_start = value
    }

    @action
    public setTermEndDate(value: string) {
        this.termination_end = value
    }

    // @action
    // public setTermDateRange(dateStrings: [string, string]) {
    //     this.termination_start = dateStrings[0]
    //     this.termination_end = dateStrings[1]
    // }

    @action
    public setContractSumStart(start: string) {
        this.contract_sum_start = start
    }

    @action
    public setContractSumEnd(end: string) {
        this.contract_sum_end = end
    }

    @action
    public setDisputeResolution(disputeResolution: string) {
        this.disputeResolution = disputeResolution
    }

    @action
    public clearFilter() {
        this.searchText = ''
        this.governingLaw = ''
        this.counterparty = ''
        this.language = ''
        this.disputeResolution = ''
        this.contractType = 0
        this.isConfidentiality = false
        this.noConfidentiality = false
        this.isChangeOfControl = false
        this.noChangeOfControl = false
        this.isIndemnity = false
        this.noIndemnity = false
        this.sensitivity = ''
        this.current = false
        this.historical = false
        this.date_sign_start = ''
        this.date_sign_end = ''
        this.termination_start = ''
        this.termination_end = ''
        this.contract_sum_start = ''
        this.contract_sum_end = ''
        this.isOpenEnded = false
        this.noOpenEnded = false
    }

    public getSearchForm(): any {
        const searchType = toJS(this.searchType)
        // const contract_sum_start = `${toJS(this.contract_sum_start)}` === '' ? 0 : toJS(this.contract_sum_start)
        // const contract_sum_end = toJS(this.contract_sum_end) <= 0 ? 1000000000000 : toJS(this.contract_sum_end)
        const contract_sum_start = this.contract_sum_start === '' ? 0 : parseFloat(this.contract_sum_start)
        const contract_sum_end = this.contract_sum_end === '' ? 1000000000000 : parseFloat(this.contract_sum_end)
        const data = {
            searchType: searchType === undefined ? 0 : searchType,
            searchText: toJS(this.searchText),
            governing_law: toJS(this.governingLaw).trim(),
            dispute_resolution: toJS(this.disputeResolution).trim(),
            counterparty: toJS(this.counterparty).trim(),
            language: toJS(this.language),
            contract_type: toJS(this.contractType),
            confidentiality: toJS(this.confidentiality),
            change_of_control: toJS(this.changeOfControl),
            indemnity: toJS(this.indemnity),
            sensitivity: toJS(this.sensitivity),
            current: toJS(this.current),
            historical: toJS(this.historical),
            date_sign_start: toJS(this.date_sign_start),
            date_sign_end: toJS(this.date_sign_end),
            term_start: toJS(this.termination_start),
            term_end: toJS(this.termination_end),
            open_ended: toJS(this.open_ended),
            contract_sum_start,
            contract_sum_end,
        }
        return data
    }
}

export default SearchStore
